module.exports = __webpack_public_path__ + "img/image12@3x.e1a0fd49.png";